import React, { Suspense, useEffect } from "react";
import { Switch, Route, Redirect, withRouter } from "react-router-dom";
import { connect } from "react-redux";

import "./assets/css/index.css";
import "./assets/css/tailwind.css";
import Spinner from "./UI/Spinner/Spinner";
import * as actions from "./store/actions/index";

const Welcome = React.lazy(() => {
  return import("./containers/Welcome/Welcome");
});

const Layout = React.lazy(() => {
  return import("./hoc/Layout/Layout");
});

const Register = React.lazy(() => {
  return import("./containers/Register/Register");
});

const Login = React.lazy(() => {
  return import("./containers/Login/Login");
});

const Chat = React.lazy(() => {
  return import("./containers/Chat/Chat");
});
const Activation = React.lazy(() => {
  return import("./containers/Activation/Activation");
});
const InscriptionSuccess = React.lazy(() => {
  return import("./containers/InscriptionSuccess/InscriptionSuccess");
});

const ForgetPassword = React.lazy(() => {
  return import("./containers/ForgetPassword/ForgetPassword");
});

const ResetPassword = React.lazy(() => {
  return import("./containers/ResetPassword/ResetPassword");
});

const Logout = React.lazy(() => {
  return import("./containers/Logout/Logout");
});

const App = (props) => {
  useEffect(() => {
    props.onAuthCheckStatus();
  }, []);

  let routes = (
    <Switch>
      <Route path="/" exact component={Welcome} />
      <Route path="/register" exact component={Register} />
      <Route path="/login" exact component={Login} />
      <Route path="/users/activate/:token" exact component={Activation} />
      <Route path="/inscription" exact component={InscriptionSuccess} />
      <Route path="/users/password/forget" exact component={ForgetPassword} />
      <Route
        path="/users/password/reset/:token"
        exact
        component={ResetPassword}
      />
      <Route
        path="/users/password/reset/:token"
        exact
        component={ResetPassword}
      />
        <Redirect to="/" />
    </Switch>
  );

  if (props.isAuthenticated) {
    routes = (
      <Switch>
        <Route path="/chat" component={Chat} />
        <Route path="/logout" exact component={Logout} />
        <Redirect to="/chat" />
      </Switch>
    );
  }
  return (
    <Suspense fallback={<Spinner />}>
      <Layout>{routes}</Layout>
    </Suspense>
  );
};
const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.token !== null,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onAuthCheckStatus: () => dispatch(actions.authCheckStatus()),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
